export default {
  FIXED: 1,
  KM: 2,
  FREE: 3
};